import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { HttpService } from '../../core/services/http/http.service';
import {
  AddCityAction,
  DeleteCityAction,
  GetAllCitiesAction,
  UpdatedCityAction,
} from './cities.actions';
import { ICiudad } from '../../core/interfaces/cities.interface';
import { EnovaAlertsComponent } from '../../core/utils/enova-alerts/enova-alerts.component';
import { MatDialog } from '@angular/material/dialog';

export interface CitiesStateModel {
  cities: ICiudad[];
}

@State<CitiesStateModel>({
  name: 'cities',
  defaults: {
    cities: [],
  },
})
@Injectable()
export class CitiesState {
  @Selector() static GetAllData(state: CitiesStateModel): ICiudad[] {
    return state?.cities ?? [];
  }

  constructor(
    private httpService: HttpService,
    private dialog: MatDialog
  ) {}

  @Action(GetAllCitiesAction)
  async GetAllCitiesAction(ctx: StateContext<CitiesStateModel>) {
    try {
      const resp = await this.httpService.getCities();
      if (resp && resp.length) {
        ctx.patchState({
          cities: resp,
        });
      }
    } catch (error) {
      this.dialog.open(EnovaAlertsComponent, {
        width: 'auto',
        data: {
          type: 'error',
          hiddeCancelBtn: true,
        },
      });
    }
  }

  @Action(AddCityAction)
  async AddCityAction(
    ctx: StateContext<CitiesStateModel>,
    { payload }: AddCityAction
  ) {
    return this.httpService
      .postCity(payload)
      .then(() => {
        this.dialog.open(EnovaAlertsComponent, {
          width: 'auto',
          data: {
            type: 'success',
            text: '¡La ciudad se ha creado de forma exitosa!',
            hiddeCancelBtn: true,
          },
        });
        ctx.dispatch(new GetAllCitiesAction());
      })
      .catch(() => {
        this.dialog.open(EnovaAlertsComponent, {
          width: 'auto',
          data: {
            type: 'error',
            hiddeCancelBtn: true,
          },
        });
      });
  }

  @Action(UpdatedCityAction)
  async UpdatedCityAction(
    ctx: StateContext<CitiesStateModel>,
    { payload }: UpdatedCityAction
  ) {
    return this.httpService
      .updateCity(payload)
      .then(() => {
        this.dialog.open(EnovaAlertsComponent, {
          width: 'auto',
          data: {
            type: 'success',
            text: '¡La ciudad se ha actualizado de forma exitosa!',
            hiddeCancelBtn: true,
          },
        });
        ctx.dispatch(new GetAllCitiesAction());
      })
      .catch(() => {
        this.dialog.open(EnovaAlertsComponent, {
          width: 'auto',
          data: {
            type: 'error',
            hiddeCancelBtn: true,
          },
        });
      });
  }

  @Action(DeleteCityAction)
  async DeleteCityAction(
    ctx: StateContext<CitiesStateModel>,
    { payload }: DeleteCityAction
  ) {
    return this.httpService
      .deleteCity(payload)
      .then(() => {
        this.dialog.open(EnovaAlertsComponent, {
          width: 'auto',
          data: {
            type: 'success',
            text: '¡La ciudad se ha eliminado de forma exitosa!',
            hiddeCancelBtn: true,
          },
        });
        ctx.dispatch(new GetAllCitiesAction());
      })
      .catch(() => {
        this.dialog.open(EnovaAlertsComponent, {
          width: 'auto',
          data: {
            type: 'error',
            hiddeCancelBtn: true,
          },
        });
      });
  }
}
